/* eslint no-shadow: ["error", { "allow": ["state", "getters"] }] */
/* eslint object-curly-newline: ["error", { "multiline": true }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import axios from 'axios';

// initial state
const state = {
  digitalPromo: null,
  loaders: {
    digitalPromo: false,
  },
};

// getters
const getters = {
  digitalPromo: (state) => state.digitalPromo,
  loaders: (state) => state.loaders,
  hasDigitalPromo: (state) => (state.digitalPromo ? state.digitalPromo.hasDigitalPromo : null),
  credits: (state) => (state.digitalPromo ? state.digitalPromo.credits : null),
  creditsTotal: (state) => (state.digitalPromo ? state.digitalPromo.creditsTotal : null),
  percentages: (state) => (state.digitalPromo ? state.digitalPromo.percentages : null),
  totalAvailable: (state) => (state.digitalPromo ? state.digitalPromo.totalAvailable : null),
  transactions: (state) => (state.digitalPromo ? state.digitalPromo.transactions : null),
  transactionsTotal: (state) => (state.digitalPromo ? state.digitalPromo.transactionsTotal : null),
  webServices: (state) => (state.digitalPromo ? state.digitalPromo.web_service_digital_promo : null),
};

// actions
const actions = {
  setProperty({ commit }, payload) {
    commit('SET_PROPERTY', payload);
  },

  /**
   * Loads Fuel Funds and associated metrics
   */
  getDigitalPromo({ commit }) {
    if (!state.digitalPromo) {
      commit('TOGGLE_LOADING', { key: 'digitalPromo', value: true });
      return axios.get(`${CONFIG.get('BASE_URL')}/api/digital-promo/`)
        .then((response) => {
          commit('SET_PROPERTY', { key: 'digitalPromo', value: response.data });
          commit('TOGGLE_LOADING', { key: 'digitalPromo', value: false });
        });
    }
    return;
  },
};

// mutations
const mutations = {
  SET_PROPERTY(state, payload) {
    state[payload.key] = payload.value;
  },
  TOGGLE_LOADING(state, payload) {
    state.loaders[payload.key] = payload.value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
